"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lensNameWithLensSuffixAsString = void 0;
/**
 * Add "Lens" suffix to lens name where required.
 */
function lensNameWithLensSuffixAsString(intl, lensName) {
    const hasLensSuffix = lensName.toLowerCase().endsWith(" lens");
    return hasLensSuffix
        ? lensName
        : intl.formatMessage({
            id: "nih7gu",
            description: "The name of the Lens with (Lens) appended",
            defaultMessage: "{lensName} Lens",
        }, { lensName });
}
exports.lensNameWithLensSuffixAsString = lensNameWithLensSuffixAsString;
//# sourceMappingURL=lensNameWithLensSuffixAsString.js.map